module.exports = __webpack_public_path__ + "static/media/mobile-phone-white.5379f600.svg";